module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    staticClass: "dispatch",
    attrs: {
      "config": _vm.pageConfig
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": [_vm.DataForm]
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "调度单号",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-col', [_vm._v(_vm._s(_vm._f("ShipmentMethod")(prop.row.ShipmentMethod)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出库地",
      "prop": "SourceWarehouse.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库地",
      "prop": "DestinationWarehouse.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "调度原因",
      "prop": "Notes"
    }
  }), _vm._v(" "), (_vm.DataForm.State === 'shipped' && _vm.DataForm.ShipmentMethod === 'external') ? _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          ref: "popover",
          attrs: {
            "placement": "left",
            "width": "500",
            "trigger": "click"
          }
        }, [_c('el-table', {
          attrs: {
            "data": _vm.ThirdPartyDeliveryInfo,
            "max-height": 300
          }
        }, [_c('el-table-column', {
          attrs: {
            "width": "180",
            "property": "time",
            "label": "时间"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "320",
            "property": "context",
            "label": "物流信息"
          }
        })], 1)], 1), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "popover",
            rawName: "v-popover:popover",
            arg: "popover"
          }],
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleGetThirdPartyDeliveryInfo(_vm.props.row.Id)
            }
          }
        }, [_vm._v("查看物流")])]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "3em"
    }
  }, [_vm._v("物料清单")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": _vm.DataForm.Lines
    }
  }, [(_vm.DataForm.State === 'verified' || _vm.DataForm.State === 'shipped') ? _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.row.LotLines), function(item) {
          return _c('el-form', {
            key: item.id,
            staticClass: "demo-table-expand table-data",
            attrs: {
              "inline": "",
              "label-position": "top"
            }
          }, [_c('el-form-item', {
            attrs: {
              "label": "批次号："
            }
          }, [_c('span', [_vm._v(_vm._s(item.Lot.Code))])]), _vm._v(" "), _c('el-form-item', {
            attrs: {
              "label": "出库地："
            }
          }, [_c('span', [_vm._v(_vm._s(item.SourceWarehouse.Name))])]), _vm._v(" "), _c('el-form-item', {
            attrs: {
              "label": "发货单："
            }
          }, [_c('span', [_vm._v(_vm._s(item.OutStockPicking.Code))])]), _vm._v(" "), _c('el-form-item', {
            attrs: {
              "label": "入库地："
            }
          }, [_c('span', [_vm._v(_vm._s(item.DestinationWarehouse.Name))])]), _vm._v(" "), _c('el-form-item', {
            attrs: {
              "label": "收货单："
            }
          }, [_c('span', [_vm._v(_vm._s(item.InStockPicking.Code))])])], 1)
        })
      }
    }])
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.Product.Name))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码:" + _vm._s(props.row.Product.Code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品项"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm._f("ConditionColor")(props.row.Condition.Name)
          }
        }, [_vm._v(_vm._s(props.row.Condition.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "prop": "Product.Brand.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型",
      "prop": "Product.Model.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "prop": "Product.Module.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "Quantity"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-col', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    attrs: {
      "inline": ""
    }
  }, [(_vm.DataForm.State === 'verified' || _vm.DataForm.State === 'shipped') ? _c('el-form-item', {
    attrs: {
      "label": "物流公司："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.DataForm.ExpressCompany.Name))])]) : _vm._e(), _vm._v(" "), (_vm.DataForm.State === 'verified' || _vm.DataForm.State === 'shipped') ? _c('el-form-item', {
    attrs: {
      "label": "物流费用："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.DataForm.ShipFee) + "元")])]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.DataForm.State === 'verified') ? _c('el-col', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "span": 12
    }
  }, [(_vm.DataForm.State !== 'confirmed') ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.handleCancel()
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.DataForm.State !== 'cancelled') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleApplySend
    }
  }, [_vm._v("同意")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.DataForm.State === 'confirmed' || _vm.DataForm.State === 'created') ? _c('el-col', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "span": 12
    }
  }, [(_vm.DataForm.State !== 'cancelled') ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.handleCancel()
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4733dd2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Order/DispatchDetail_order.vue
// module id = 733
// module chunks = 0